import React from "react";
import { connect } from "react-redux";

const MINavigation = (props) => {
  const { activeTab, onTabChange, tabs } = props;
  return (
   <div className="custom-tabs-container p-1 rounded-3">
        <ul className="nav nav-pills">
          <li className="nav-item">
            <button 
                className={`nav-link py-2 px-4 ${activeTab === tabs.SHAREHOLDINGS ? 'mi-menu-active text-dark' : 'text-muted'}`} 
                type="button"
                onClick={() => onTabChange(tabs.SHAREHOLDINGS)}
            >
              Shareholdings
            </button>
          </li>
          <li className="nav-item">
            <button 
                className={`nav-link py-2 px-4 ${activeTab === tabs.ANALYST_RATINGS ? 'mi-menu-active text-dark' : 'text-muted'}`} 
                type="button"
                onClick={() => onTabChange(tabs.ANALYST_RATINGS)}
            >
              Analyst Ratings
            </button>
          </li>
          <li className="nav-item">
            <button
                className={`nav-link py-2 px-4 ${activeTab === tabs.FILINGS ? 'mi-menu-active text-dark' : 'text-muted'}`}
                type="button"
                onClick={() => onTabChange(tabs.FILINGS)}
            >
              Filings
            </button>
          </li>
          <li className="nav-item">
            <button 
                className={`nav-link py-2 px-4 ${activeTab === tabs.UPDATES ? 'mi-menu-active text-dark' : 'text-muted'}`} 
                type="button"
                onClick={() => onTabChange(tabs.UPDATES)}
            >
              Updates
            </button>
          </li>
          <li className="nav-item">
            <button
                className={`nav-link py-2 px-4 ${activeTab === tabs.INSIDERS ? 'mi-menu-active text-dark' : 'text-muted'}`}
                type="button"
                onClick={() => onTabChange(tabs.INSIDERS)}
            >
              Insiders
            </button>
          </li>
          <li className="nav-item">
            <button
                className={`nav-link py-2 px-4 ${activeTab === tabs.METRICS ? 'mi-menu-active text-dark' : 'text-muted'}`}
                type="button"
                onClick={() => onTabChange(tabs.METRICS)}
            >
              Metrics
            </button>
          </li>
          <li className="nav-item">
            <button 
                className={`nav-link py-2 px-4 ${activeTab === tabs.SENTIMENT ? 'active mi-menu-active text-dark' : 'text-muted'}`} 
                type="button"
                onClick={() => onTabChange(tabs.SENTIMENT)}
            >
              Intrinsic Intelligence
            </button>
          </li>
        </ul>
      </div>
    
  );
};

export default connect(null, {})(MINavigation);
